<template>
  <div class="bg-white dark:bg-gray-800 shadow-md rounded-lg overflow-hidden">
    <!-- Desktop table (hidden on mobile) -->
    <table class="hidden md:table min-w-full divide-y divide-gray-200 dark:divide-gray-700">
      <thead class="bg-gray-50 dark:bg-gray-900">
        <tr>
          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
          >
            Weergavenaam
          </th>
          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
          >
            Organization ID
          </th>
          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
          >
            Toegevoegd op
          </th>
          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
          >
            Toegevoegd door
          </th>
          <th scope="col" class="relative px-6 py-3">
            <span class="sr-only">Acties</span>
          </th>
        </tr>
      </thead>
      <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
        <tr
          v-for="account in accounts"
          :key="account.id"
          class="hover:bg-gray-50 dark:hover:bg-gray-700"
        >
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="text-sm font-medium text-gray-900 dark:text-white">
              {{ account.display_name }}
            </div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="text-sm text-gray-500 dark:text-gray-400 font-mono">
              {{ account.organization_id }}
            </div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
            {{ formatDate(account.created_at) }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
            {{ account.created_by_name || account.created_by_email || '-' }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
            <button
              @click="$emit('delete', account)"
              class="text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300"
              title="Verwijderen"
            >
              <TrashIcon class="h-4 w-4" />
            </button>
          </td>
        </tr>
        <tr v-if="accounts.length === 0">
          <td colspan="5" class="px-6 py-12 text-center text-gray-500 dark:text-gray-400">
            Geen Top Accounts toegevoegd
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Mobile cards (visible only on mobile) -->
    <div class="md:hidden divide-y divide-gray-200 dark:divide-gray-700">
      <div
        v-for="account in accounts"
        :key="account.id"
        class="p-4 hover:bg-gray-50 dark:hover:bg-gray-700"
      >
        <div class="flex items-start justify-between gap-3">
          <div class="flex-1 min-w-0">
            <div class="text-sm font-medium text-gray-900 dark:text-white">
              {{ account.display_name }}
            </div>
            <div class="text-xs text-gray-500 dark:text-gray-400 font-mono mt-0.5 truncate">
              {{ account.organization_id }}
            </div>
          </div>
          <button
            @click="$emit('delete', account)"
            class="p-2 text-red-600 hover:text-red-900 dark:text-red-400 dark:hover:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-md flex-shrink-0"
            title="Verwijderen"
          >
            <TrashIcon class="h-5 w-5" />
          </button>
        </div>
        <div class="mt-2 text-xs text-gray-500 dark:text-gray-400">
          Toegevoegd: {{ formatDate(account.created_at) }}
          <span v-if="account.created_by_name || account.created_by_email">
            door {{ account.created_by_name || account.created_by_email }}
          </span>
        </div>
      </div>
      <div
        v-if="accounts.length === 0"
        class="px-4 py-12 text-center text-gray-500 dark:text-gray-400"
      >
        Geen Top Accounts toegevoegd
      </div>
    </div>
  </div>
</template>

<script setup>
import { TrashIcon } from '@heroicons/vue/24/outline'

defineProps({
  accounts: {
    type: Array,
    required: true
  }
})

defineEmits(['delete'])

const formatDate = dateString => {
  if (!dateString) return '-'
  return new Date(dateString).toLocaleDateString('nl-NL', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  })
}
</script>
